//
//
//
//
//
//
//
//
//
//
export default {
  name: 'u8-sms-cd',
  props: {
    total: {
      default: 60
    },
    storeId: {
      default: 'sms'
    }
  },
  data: function data() {
    return {
      state: 0,
      currCount: ''
    };
  },
  methods: {
    countDown: function countDown() {
      var _this = this;

      this.$emit('click');
      this.currCount = this.total;
      this.state = 1;
      var clock = window.setInterval(function () {
        _this.currCount = _this.currCount - 1;

        if (_this.currCount < 0) {
          //当倒计时小于0时清除定时器
          window.clearInterval(clock);
          _this.state = 2;
        }
      }, 1000);
    }
  }
};